<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

withDefaults(defineProps<Props>(), {
  isActive: undefined,
  variant: 'default',
  size: 'default',
})

const menuButtonVariants = cva(
  'peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md px-2 py-1.5 text-sm font-medium outline-none ring-sidebar-ring transition-all hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-data-[collapsible=icon]/sidebar:justify-center group-data-[collapsible=icon]/sidebar:px-0 [&>svg]:size-4 [&>svg]:shrink-0 [&>span]:group-data-[collapsible=icon]/sidebar:hidden',
  {
    variants: {
      isActive: {
        true: 'bg-sidebar-accent text-sidebar-accent-foreground',
      },
      variant: {
        default: 'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
        outline:
          'border border-sidebar-border bg-background hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:border-sidebar-accent',
      },
      size: {
        default: 'h-8',
        sm: 'h-7 text-xs',
        lg: 'h-12 text-base group-data-[collapsible=icon]/sidebar:!p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

type MenuButtonVariants = VariantProps<typeof menuButtonVariants>

interface Props extends /* @vue-ignore */ MenuButtonVariants {
  class?: HTMLAttributes['class']
  asChild?: boolean
  size?: 'default' | 'sm' | 'lg'
}
</script>

<template>
  <button
    v-if="!$props.asChild"
    :class="
      cn(
        menuButtonVariants({
          isActive: $props.isActive,
          variant: $props.variant,
          size: $props.size,
        }),
        $props.class
      )
    "
  >
    <slot />
  </button>
  <div
    v-else
    :class="
      cn(
        menuButtonVariants({
          isActive: $props.isActive,
          variant: $props.variant,
          size: $props.size,
        }),
        $props.class
      )
    "
  >
    <slot />
  </div>
</template>
